import ListViewCardSkeleton from '@/components/skeletons/ListViewCardSkeleton';

export default function ListViewSkeleton(): JSX.Element {
  const venues: Array<JSX.Element> = [];
  for (let i = 0; i < 50; i++) {
    venues.push(
      <li key={`${i}-key`}>
        <ListViewCardSkeleton />
      </li>
    );
  }
  return <ul data-cvent-id="list-view-card-skeleton">{venues}</ul>;
}
